<!-- =========================================================================================
    File Name: ChatLog.vue
    Description: Chat Application - Log of chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<!-- hasSentPreviousMsg -->
<template>
  <div id="compare">
    <!-- <pre>{{artefact}}</pre> -->
    <vs-prompt title="Export To Excel" class="export-options" @cancle="clearFields" @accept="exportToExcel" accept-text="Export" @close="clearFields" :active.sync="activePrompt">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

    <vx-card v-if="false && artefact && artefact.res && !artefact.res.detail && artefact.res.error">
      <h2>Note</h2>

      <vs-alert color="danger" icon="new_releases" active="true" class="mt-5">
        <p>{{artefact.res.error}}</p>
      </vs-alert>
    </vx-card>
    <vx-card
      v-if="artefact && artefact.res && artefact.res.detail && !artefact.res.error"
      :title="artefact.type + ' by ' + (artefact.mode === 'revenue' ? 'Sales ( '+currency+' )' : 'Quantity Sold')"
      subtitle="Visualize the comparison by selecting the tags below"
    >
      <div class="flex flex-wrap items-center md:justify-between">
        <div class="flex flex-wrap">
          <!-- <span class="tagger bg-primary-gradient text-white">{{ artefact.tags[0].tag }}</span>
          <span class="p-3">vs</span> -->
          <!-- <span
            v-for="(tag, index) in fetchCompareTags()"
            :key="index"
            @click="updateVisualizer(tag)"
            class="tagger cursor-pointer"
            :class="selectedTag(index)"
          >{{tag.tag}}</span> -->
          <vs-chip color="primary" class="bg-primary-gradient" closable close-icon="check_box">
            <vs-avatar :text="artefact.tags[1].type" />
            {{ artefact.tags[1].tag }}
          </vs-chip>
          <span class="mr-5 ml-5 mt-1">vs</span>
          <vs-chip @click="updateVisualizer(tag)" class="cursor-pointer" :class="selectedTag(index)" closable :close-icon="selectedIcon(index)" v-for="(tag, index) in fetchCompareTags()" :key="index">
            <vs-avatar :text="tag.type" />
            {{ tag.tag }}
          </vs-chip>
        </div>
      </div>

      <vs-alert color="primary" icon="new_releases" active="true" class="mt-5" v-if="artefact.note">
        <p>{{artefact.note}}</p>
      </vs-alert>
    </vx-card>
    <div
      class="mt-base"
      v-if="artefact && artefact.res && artefact.res.detail && !artefact.res.error"
    >
      <div class="vx-row">
        <!-- CARD 1: OVERVIEW -->
        <div class="vx-col w-full lg:w-1/2 mb-base">
          <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
            <feather-icon
              icon="ThumbsUpIcon"
              class="p-6 mb-8 bg-white inline-flex rounded-full text-primary shadow"
              svgClasses="h-8 w-8"
            ></feather-icon>
            <h1 class="mb-6 text-white">{{this.fetchPerformer() | ellipsis(30)}}</h1>
            <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
              performing better by
              <strong>{{(artefact.mode === 'revenue' ? 'Sales ( '+currency+' )' : 'Quantity Sold')}}</strong>
              ( {{artefact.dateRange.startDate | date(true)}} - {{artefact.dateRange.endDate | date(true)}} )
            </p>
            <p>
              
            </p>
            <p class="text-white">
              <strong>Index # {{calculateOverallDI() | numFormat('0.00')}} ~ TOR # {{calculateOverallTOR() | numFormat('0.00')}}</strong>
            </p>
          </vx-card>
        </div>

        <!-- CARD 2: BASE UNIT -->
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
          <statistics-card-line
            icon="BookmarkIcon"
            :statistic="fetchStat('base', baseTag) | numFormat(artefact.mode === 'revenue' ? '$ 0,0' : '')"
            :statisticTitle="fetchTagOf('base', baseTag)"
            :chartData="makeUnitStatsData('base', baseTag)"
            :color="baseChartColor"
            type="area"
          ></statistics-card-line>
        </div>

        <!-- CARD 3: COMPARE UNIT -->
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
          <statistics-card-line
            icon="FilterIcon"
            :statistic="fetchStat('comparison', compareTag) | numFormat(artefact.mode === 'revenue' ? '$ 0,0' : '')"
            :statisticTitle="fetchTagOf('comparison', compareTag)"
            :chartData="makeUnitStatsData('comparison', compareTag)"
            :color="compareChartColor"
            type="area"
          ></statistics-card-line>
        </div>
      </div>
      <div class="vx-row">
        <!-- CARD 1: BASE UNIT's SPLIT -->
        <div class="vx-col w-full mb-base" :class="showStatsPanel ? 'lg:w-1/3' : 'lg:w-1/2'">
          <vx-card :title="fetchTagOf('base', baseTag)" subtitle="Base Units" class="mt-base">
            <template slot="actions">
              <!-- <feather-icon
                icon="XCircleIcon"
                svgClasses="w-6 h-6 text-grey"
                @click="hideAlertContainer"
              ></feather-icon> -->

              <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                <!-- <feather-icon
                  icon="XCircleIcon"
                  class="cursor-pointer"
                  :svgClasses="['w-5', 'h-5 mr-4']"
                  @click.stop="hideAlertContainer" /> -->

                <feather-icon
                  icon="DownloadIcon"
                  class="cursor-pointer"
                  :svgClasses="['text-success stroke-current', 'w-5', 'h-5 mr-4']"
                  @click.stop="activatePrompt('base', baseTag)" />

                <!-- <feather-icon
                  icon="XCircleIcon"
                  class="cursor-pointer"
                  :svgClasses="['w-5', 'h-5 mr-4']"
                  @click.stop="hideAlertContainer" /> -->

              </div>

              <!-- <vs-button @click="activePrompt=true">Export</vs-button> -->
            </template>
            <vs-table
              pagination
              :max-items="maxItems"
              search
              :data="fetchDataOf('base', baseTag)"
              @selected="handleBaseSelected"
            >
              <template slot="thead">
                <vs-th sort-key="row_no">Rank</vs-th>
                <vs-th sort-key="desc">Unit Reference</vs-th>
                <vs-th
                  sort-key="metric"
                  v-show="!showStatsPanel"
                >{{artefact.mode === 'revenue' ? 'Sales ( '+currency+' )' : 'Quantity Sold'}}</vs-th>
                <vs-th sort-key="index" v-show="!showStatsPanel">Index</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr
                  :state="applyState('base', tr, indextr)"
                  :data="tr"
                  :key="indextr"
                  v-for="(tr, indextr) in data"
                >
                  <vs-td :data="data[indextr].row_no">{{ data[indextr].row_no }}</vs-td>
                  <vs-td :data="data[indextr].desc">{{ data[indextr].desc }}<br><small class="text-grey">{{ data[indextr].sku_id }}</small></vs-td>
                  <vs-td align="right"
                    :data="data[indextr].metric"
                    v-show="!showStatsPanel"
                  >{{ data[indextr].metric }}</vs-td>
                  <vs-td
                    :data="data[indextr].index"
                    v-show="!showStatsPanel"
                  >{{ data[indextr].index }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
        <!-- CARD 2: COMPARE UNIT's SPLIT -->
        <div class="vx-col w-full mb-base" :class="showStatsPanel ? 'lg:w-1/3' : 'lg:w-1/2'">
          <vx-card :title="fetchTagOf('comparison', compareTag)" subtitle="Compare Units" class="mt-base">
            <template slot="actions">
              <!-- <feather-icon
                icon="XCircleIcon"
                svgClasses="w-6 h-6 text-grey"
                @click="hideAlertContainer"
              ></feather-icon> -->

              <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                <!-- <feather-icon
                  icon="XCircleIcon"
                  class="cursor-pointer"
                  :svgClasses="['w-5', 'h-5 mr-4']"
                  @click.stop="hideAlertContainer" /> -->

                <feather-icon
                  icon="DownloadIcon"
                  class="cursor-pointer"
                  :svgClasses="['text-success stroke-current', 'w-5', 'h-5 mr-4']"
                  @click.stop="activatePrompt('comparison', compareTag)" />

                <!-- <feather-icon
                  icon="XCircleIcon"
                  class="cursor-pointer"
                  :svgClasses="['w-5', 'h-5 mr-4']"
                  @click.stop="hideAlertContainer" /> -->

              </div>

              <!-- <vs-button @click="activePrompt=true">Export</vs-button> -->
            </template>
            <vs-table
              pagination
              :max-items="maxItems"
              search
              :data="fetchDataOf('comparison', compareTag)"
              @selected="handleCompareSelected"
            >
              <template slot="thead">
                <vs-th sort-key="row_no">Rank</vs-th>
                <vs-th sort-key="desc">Unit Reference</vs-th>
                <vs-th
                  sort-key="metric"
                  v-show="!showStatsPanel"
                >{{artefact.mode === 'revenue' ? 'Sales ( '+currency+' )' : 'Quantity Sold'}}</vs-th>
                <vs-th sort-key="index" v-show="!showStatsPanel">Index</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr
                  :state="applyState('comparison', tr, indextr)"
                  :data="tr"
                  :key="indextr"
                  v-for="(tr, indextr) in data"
                >
                  <vs-td :data="data[indextr].row_no">{{ data[indextr].row_no }}</vs-td>
                  <vs-td :data="data[indextr].desc">{{ data[indextr].desc }}<br><small class="text-grey">{{ data[indextr].sku_id }}</small></vs-td>
                  <vs-td align="right"
                    :data="data[indextr].metric"
                    v-show="!showStatsPanel"
                  >{{ data[indextr].metric }}</vs-td>
                  <vs-td
                    :data="data[indextr].index"
                    v-show="!showStatsPanel"
                  >{{ data[indextr].index }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
        <!-- CARD 3: OVERVIEW -->
        <div class="vx-col w-full lg:w-1/3 mb-base" v-show="showCompare || showUnitContrib">
          <vx-card class="overlay-card overflow-hidden mt-base" v-show="showCompare">
            <template slot="no-body">
                <img :src="require('@/assets/images/pages/card-image-5.jpg')" alt="performance-compare" class="responsive blur-1">
                <div class="card-overlay text-white">
                    <div class="flex flex-col justify-between h-full">
                        <div class="text-center mt-5 w-full">
                            <h3 class="text-white mb-2 tracking-wide">Performance</h3>
                            <p class="mb-6">{{'by ' + (artefact.mode === 'revenue' ? 'Sales ( '+currency+' )' : 'Quantity Sold')}}</p>
                            <div class="flex justify-around">
                              <div>
                                <h2 class="text-white text-big">{{calculateDI(compareUnitSelected.index) | round(2)}}</h2>
                                <p>% Diff Index</p>
                              </div>
                              <div>
                                <h2 class="text-white text-big">{{calculateTOR(compareUnitSelected.index) | round(2) | k_formatter}}</h2>
                                <p>Turn Over Rate</p>
                              </div>
                            </div>
                        </div>
                        <div class="text-center w-full">
                          <small>For every unit of <strong>{{compareUnitSelected.desc}}</strong> sold, <strong>{{baseUnitSelected.desc}}</strong> sells {{calculateTOR(compareUnitSelected.index) | round(2) | k_formatter}} units</small>
                        </div>
                        <div class="text-center w-full">
                          <span>{{baseUnitSelected.desc}}</span>
                          <p>vs</p>
                          <span>{{compareUnitSelected.desc}}</span> 
                        </div>
                        <div class="text-center w-full">
                            <div class="flex justify-between px-8 mb-4 text-xl">
                                <span>Base {{(artefact.mode === 'revenue' ? 'Sales' : 'Quantity Sold')}}</span>
                                <span>{{baseUnitSelected.metric | numFormat(artefact.mode === 'revenue' ? '$ 0.0 a' : '0.0 a')}}</span>
                            </div>
                            <div class="flex justify-between px-8 mb-4 text-xl">
                                <span>Base Index</span>
                                <span>{{baseUnitSelected.index | numFormat('0.00')}}</span>
                            </div>
                            <div class="flex justify-between px-8 mb-4 text-xl">
                                <span>Compare {{(artefact.mode === 'revenue' ? '$ Sales' : 'Quantity Sold')}}</span>
                                <span>{{compareUnitSelected.metric | numFormat(artefact.mode === 'revenue' ? '$ 0.0 a' : '0.0 a')}}</span>
                            </div>
                            <div class="flex justify-between px-8 mb-4 text-xl">
                                <span>Compare Index</span>
                                <span>{{compareUnitSelected.index | numFormat('0.00')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
          </vx-card>
          <!-- <vx-card :title="'Performance by ' + (artefact.mode === 'revenue' ? '$ Sales' : 'Quantity Sold')" class="mt-base" v-if="showCompare">
            <template slot="actions">
              <feather-icon icon="HelpCircleIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
            </template> -->

            <!-- CHART -->
            <!-- <template slot="no-body">
              <div class="mt-10">
                <vue-apex-charts
                  type="radialBar"
                  height="240"
                  :options="goalOverviewRadialBar.chartOptions"
                  :series="[calculateTOR(compareUnitSelected.index) | round]"
                />
              </div>
            </template>-->

            <!-- DATA -->
            <!-- <div class="flex justify-between text-center mt-4" slot="no-body-bottom">
              <div
                class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0"
              >
                <p class="mt-4">Performance Index</p>
                <p
                  class="mb-4 text-3xl font-bold"
                >{{calculateDI(compareUnitSelected.index) | round(2)}}</p>
              </div>
              <div
                class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0"
              >
                <p class="mt-4">Turn Over Rate</p>
                <p
                  class="mb-4 text-3xl font-bold"
                >{{calculateTOR(compareUnitSelected.index) | round(2)}}</p>
              </div>
            </div>
            <div class="flex justify-between text-center" slot="no-body-bottom">
              <div
                class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0"
              >
                <p class="mt-4">Base $ Sales</p>
                <p class="mb-4 text-2xl font-semibold">{{baseUnitSelected.metric | k_formatter}}</p>
              </div>
              <div
                class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0"
              >
                <p class="mt-4">Base Index</p>
                <p class="mb-4 text-2xl font-semibold">{{baseUnitSelected.index | round(2)}}</p>
              </div>
            </div>
            <div class="flex justify-between text-center" slot="no-body-bottom">
              <div
                class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0"
              >
                <p class="mt-4">Compare $ Sales</p>
                <p class="mb-4 text-2xl font-semibold">{{compareUnitSelected.metric | k_formatter}}</p>
              </div>
              <div
                class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0"
              >
                <p class="mt-4">Compare Index</p>
                <p class="mb-4 text-2xl font-semibold">{{compareUnitSelected.index | round(2)}}</p>
              </div>
            </div> -->
            <!-- <div class="flex justify-between text-center" slot="no-body-bottom">
              <div
                class="w-full border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0"
              >
                <p class="mt-4">Performance Index</p>
                <p
                  class="mb-4 text-3xl font-semibold"
                >{{calculateDI(compareUnitSelected.index) | round(2)}}</p>
              </div>
            </div>-->
          <!-- </vx-card> -->
          <vx-card :title="'Unit History by ' + (artefact.mode === 'revenue' ? 'Sales ( '+currency+' )' : 'Quantity Sold ( Units )')" :subtitle="fetchTagOfSelectedUnitStats()" class="mt-base" v-show="showUnitContrib">
            <!-- <pre>{{selectedUnitStats}}</pre> -->
            <div id="history-panel"></div>
            <div class="mt-4">
              <div class="flex justify-between">
                <div class="flex flex-col">
                  <span class="mb-1">Last day</span>
                  <!-- <h4>{{ findUnitProgress(selectedUnitStats.last_day, selectedUnitStats.year_from) | k_formatter }}%</h4> -->
                </div>
                <div class="flex flex-col text-right">
                  <span class="flex -mr-1">
                    <span class="mr-1 font-semibold">{{selectedUnitStats.last_day | numFormat(artefact.mode === 'revenue' ? '$ 0,0' : '')}}</span>
                    <feather-icon
                      :icon="findUnitProgress(selectedUnitStats.last_day, selectedUnitStats.year_from) <= 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'"
                      :svgClasses="[findUnitProgress(selectedUnitStats.last_day, selectedUnitStats.year_from) <= 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"
                    ></feather-icon>
                  </span>
                  <!-- <span class="text-grey">{{ browser.time | time(true) }}</span> -->
                </div>
              </div>
              <vs-progress :color="findUnitProgress(selectedUnitStats.last_day, selectedUnitStats.year_from) <= 0 ? 'danger' : 'primary'" :percent="findUnitProgress(selectedUnitStats.last_day, selectedUnitStats.year_from)"></vs-progress>
            </div>
            <div class="mt-4">
              <div class="flex justify-between">
                <div class="flex flex-col">
                  <span class="mb-1">Last Week</span>
                  <!-- <h4>{{ findUnitProgress(selectedUnitStats.week_from, selectedUnitStats.year_from) | k_formatter}}%</h4> -->
                </div>
                <div class="flex flex-col text-right">
                  <span class="flex -mr-1">
                    <span class="mr-1 font-semibold">{{ selectedUnitStats.week_from | numFormat(artefact.mode === 'revenue' ? '$ 0,0' : '') }}</span>
                    <feather-icon
                      :icon="findUnitProgress(selectedUnitStats.week_from, selectedUnitStats.year_from) <= 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'"
                      :svgClasses="[findUnitProgress(selectedUnitStats.week_from, selectedUnitStats.year_from) <= 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"
                    ></feather-icon>
                  </span>
                  <!-- <span class="text-grey">{{ browser.time | time(true) }}</span> -->
                </div>
              </div>
              <vs-progress :color="findUnitProgress(selectedUnitStats.week_from, selectedUnitStats.year_from) <= 0 ? 'danger' : 'success'" :percent="findUnitProgress(selectedUnitStats.week_from, selectedUnitStats.year_from)"></vs-progress>
            </div>
            <div class="mt-4">
              <div class="flex justify-between">
                <div class="flex flex-col">
                  <span class="mb-1">Last Month</span>
                  <!-- <h4>{{ findUnitProgress(selectedUnitStats.month_from, selectedUnitStats.year_from) | k_formatter }}%</h4> -->
                </div>
                <div class="flex flex-col text-right">
                  <span class="flex -mr-1">
                    <span class="mr-1 font-semibold">{{ selectedUnitStats.month_from | numFormat(artefact.mode === 'revenue' ? '$ 0,0' : '') }}</span>
                    <feather-icon
                      :icon="findUnitProgress(selectedUnitStats.month_from, selectedUnitStats.year_from) <= 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'"
                      :svgClasses="[findUnitProgress(selectedUnitStats.month_from, selectedUnitStats.year_from) <= 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"
                    ></feather-icon>
                  </span>
                  <!-- <span class="text-grey">{{ browser.time | time(true) }}</span> -->
                </div>
              </div>
              <vs-progress :color="findUnitProgress(selectedUnitStats.month_from, selectedUnitStats.year_from) <= 0 ? 'danger' : 'success'" :percent="findUnitProgress(selectedUnitStats.month_from, selectedUnitStats.year_from)"></vs-progress>
            </div>
            <div class="mt-4">
              <div class="flex justify-between">
                <div class="flex flex-col">
                  <span class="mb-1">Last Quarter</span>
                  <!-- <h4>{{ findUnitProgress(selectedUnitStats.quarter_from, selectedUnitStats.year_from) | k_formatter }}%</h4> -->
                </div>
                <div class="flex flex-col text-right">
                  <span class="flex -mr-1">
                    <span class="mr-1 font-semibold">{{ selectedUnitStats.quarter_from | numFormat(artefact.mode === 'revenue' ? '$ 0,0' : '') }}</span>
                    <feather-icon
                      :icon="findUnitProgress(selectedUnitStats.quarter_from, selectedUnitStats.year_from) <= 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'"
                      :svgClasses="[findUnitProgress(selectedUnitStats.quarter_from, selectedUnitStats.year_from) <= 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"
                    ></feather-icon>
                  </span>
                  <!-- <span class="text-grey">{{ browser.time | time(true) }}</span> -->
                </div>
              </div>
              <vs-progress :color="findUnitProgress(selectedUnitStats.quarter_from, selectedUnitStats.year_from) <= 0 ? 'danger' : 'success'" :percent="findUnitProgress(selectedUnitStats.quarter_from, selectedUnitStats.year_from)"></vs-progress>
            </div>
            <div class="mt-4">
              <div class="flex justify-between">
                <div class="flex flex-col">
                  <span class="mb-1">Last Year</span>
                  <!-- <h4>{{ findUnitProgress(selectedUnitStats.year_from, selectedUnitStats.year_from) | k_formatter }}%</h4> -->
                </div>
                <div class="flex flex-col text-right">
                  <span class="flex -mr-1">
                    <span class="mr-1 font-semibold">{{ selectedUnitStats.year_from | numFormat(artefact.mode === 'revenue' ? '$ 0,0' : '') }}</span>
                    <feather-icon
                      :icon="findUnitProgress(selectedUnitStats.year_from, selectedUnitStats.year_from) <= 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'"
                      :svgClasses="[findUnitProgress(selectedUnitStats.year_from, selectedUnitStats.year_from) <= 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"
                    ></feather-icon>
                  </span>
                  <!-- <span class="text-grey">{{ browser.time | time(true) }}</span> -->
                </div>
              </div>
              <vs-progress :color="findUnitProgress(selectedUnitStats.year_from, selectedUnitStats.year_from) <= 0 ? 'danger' : 'success'" :percent="findUnitProgress(selectedUnitStats.year_from, selectedUnitStats.year_from)"></vs-progress>
            </div>

            <vs-divider></vs-divider>
            <div class="my-6">
                <h5 class="mb-2">Note</h5>
                <p class="text-grey">The above period is with reference to {{artefact.dateRange.startDate | date(true)}}</p>
            </div>
          </vx-card>
          <!-- <vx-card title="Individual Units Contribution" class="mt-base" v-if="showUnitContrib">
            <ul class="activity-timeline">
              <li>
                <div class="timeline-icon bg-primary">
                  <feather-icon icon="PlusIcon" svgClasses="text-white stroke-current w-4 h-4"></feather-icon>
                </div>
                <div class="timeline-info">
                  <p class="font-semibold">{{selectedUnitStats.last_day}}</p>
                </div>
                <small class="text-grey activity-e-time">yesterday</small>
              </li>
              <li>
                <div class="timeline-icon bg-warning">
                  <feather-icon
                    icon="AlertCircleIcon"
                    svgClasses="text-white stroke-current w-5 h-5"
                  ></feather-icon>
                </div>
                <div class="timeline-info">
                  <p class="font-semibold">{{selectedUnitStats.week_from}}</p>
                </div>
                <small class="text-grey activity-e-time">last week</small>
              </li>
              <li>
                <div class="timeline-icon bg-success">
                  <feather-icon icon="CheckIcon" svgClasses="text-white stroke-current w-5 h-5"></feather-icon>
                </div>
                <div class="timeline-info">
                  <p class="font-semibold">{{selectedUnitStats.month_from}}</p>
                </div>
                <small class="text-grey activity-e-time">last month</small>
              </li>
              <li>
                <div class="timeline-icon bg-success">
                  <feather-icon icon="CheckIcon" svgClasses="text-white stroke-current w-5 h-5"></feather-icon>
                </div>
                <div class="timeline-info">
                  <p class="font-semibold">{{selectedUnitStats.quarter_from}}</p>
                </div>
                <small class="text-grey activity-e-time">last quarter</small>
              </li>
              <li>
                <div class="timeline-icon bg-success">
                  <feather-icon icon="CheckIcon" svgClasses="text-white stroke-current w-5 h-5"></feather-icon>
                </div>
                <div class="timeline-info">
                  <p class="font-semibold">{{selectedUnitStats.year_from}}</p>
                </div>
                <small class="text-grey activity-e-time">last year</small>
              </li>
              <li>
                <div class="timeline-icon bg-success">
                  <feather-icon icon="CheckIcon" svgClasses="text-white stroke-current w-5 h-5"></feather-icon>
                </div>
                <div class="timeline-info">
                  <p class="font-semibold">{{selectedUnitStats.last_n_from}}</p>
                </div>
                <small class="text-grey activity-e-time">days from start of month</small>
              </li>
            </ul>
          </vx-card>-->
        </div>
      </div>
    </div>
    <!-- <vue-apex-charts
                  type="line"
                  height="350"
                  :options="mixedChart.chartOptions"
                  :series="mixedChart.series"
    ></vue-apex-charts>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import VueApexCharts from "vue-apexcharts";
import vSelect from 'vue-select';
import StatisticsCardLine from "@/app/shared/components/statistics-cards/StatisticsCardLine.vue";
import ChangeTimeDurationDropdown from "@/app/shared/components/ChangeTimeDurationDropdown.vue";

import { appCommons } from "@/app/shared/services";
import {fetchArtefactUnit} from "../shared/services";

import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import appConfig from "@/../appConfig.js";

const themeColors = appConfig.chart.colors;

export default {
  props: {
    artefact: { type: Object, required: true }
  },
  data() {
    return {
      currency: this.$options.filters.currencySymbol(''),
      baseTag: "0",
      compareTag: "0",
      baseUnitSelected: [],
      compareUnitSelected: [],
      baseChartColor: "success",
      compareChartColor: "warning",
      showCompare: false,
      showUnitContrib: false,
      showStatsPanel: false,
      payload: null,
      selectedUnitStats: {
      //   last_day: 0.0,
      //   week_from: 3.0,
      //   month_from: 6.0,
      //   quarter_from: 6.0,
      //   year_from: 42.0,
      //   last_n_from: 10.0
      },

      maxItems: 8,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot"
      ],

      // STATS CARD PLOT
      unitStatsData: {
        series: [
          {
            name: "",
            data: []
          }
        ],
        chartOptions: {
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 0
            }
          },
          chart: {
            toolbar: {
              show: false
            },
            sparkline: {
              enabled: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: "smooth",
            width: 2.5
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 0.9,
              opacityFrom: 0.7,
              opacityTo: 0.5,
              stops: [0, 80, 100]
            }
          },
          xaxis: {
            type: "numeric",
            lines: {
              show: false
            },
            axisBorder: {
              show: false
            },
            labels: { show: false }
          },
          yaxis: [
            {
              y: 0,
              offsetX: 0,
              offsetY: 0,
              padding: { left: 0, right: 0 }
            }
          ],
          tooltip: {
            x: { show: false }
          }
        }
      },

      // RADIAL BAR
      goalOverviewRadialBar: {
        series: [83],
        chartOptions: {
          plotOptions: {
            radialBar: {
              size: 110,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: "77%"
              },
              track: {
                background: "#bfc5cc",
                strokeWidth: "50%"
              },
              dataLabels: {
                name: {
                  show: false
                },
                value: {
                  offsetY: 18,
                  color: "#99a2ac",
                  fontSize: "4rem"
                }
              }
            }
          },
          colors: ["#00db89"],
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 0.5,
              gradientToColors: ["#00b5b5"],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100]
            }
          },
          stroke: {
            lineCap: "round"
          },
          chart: {
            sparkline: {
              enabled: true
            },
            dropShadow: {
              enabled: true,
              blur: 3,
              left: 1,
              top: 1,
              opacity: 0.1
            }
          }
        }
      },

      fileName: "",
      formats:["xlsx", "csv", "txt"] ,
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: ["SKU Id", "Unit Desc.", "Value", "Rank", "Index"],
      headerVal: ["sku_id", "desc", "metric","row_no", "index"],
      activePrompt: false,
      exportData: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleBaseSelected(tr) {
      this.baseUnitSelected =
        this.baseUnitSelected.row_no === tr.row_no ? [] : tr;
      this.checkStatsPanel();
      this.fetchPerformanceHistory();
    },
    handleCompareSelected(tr) {
      this.compareUnitSelected =
        this.compareUnitSelected.row_no === tr.row_no ? [] : tr;
      this.checkStatsPanel();
      this.fetchPerformanceHistory();
    },
    applyState(unitType, tr, indextr) {
      if (unitType === "base") {
        return tr.row_no === this.baseUnitSelected.row_no ? "dark" : "";
      } else {
        return tr.row_no === this.compareUnitSelected.row_no ? "dark" : "";
      }
    },
    fetchCompareTags() {
      let tags = [];
      let queryType = this.artefact.type;
      if(queryType === 'CDI') {
        tags = this.artefact.tags.filter(
              t => (t.type === 'C')
            );
        tags = tags.slice(1);
      } else {
        tags = this.artefact.tags.filter(
                    t => (t.type === 'B')
                  );
        tags = tags.slice(1);
      }
      // console.log('fetchCompareTags', tags);
      return tags;
    },
    fetchTagOf(ref, pos) {
      console.log('fetchTagOf', ref, pos, this.artefact.tags);
      if(ref === 'base')
        return this.artefact.tags[1].tag;
      else
        return this.artefact.tags[Number(pos)+2].tag;
      // return this.artefact.res.detail[ref][pos][0]
      //   ? this.artefact.res.detail[ref][pos][0].pointer
      //   : this.fetchCompareTags()[pos].tag;
    },
    fetchDataOf(ref, pos) {
      let data = this.artefact.res.detail[ref][pos];
      let sortedData = [];
      Object.assign(sortedData, data);
      return sortedData.sort(function(a, b){return b.metric-a.metric});
    },
    selectedTag(pos) {
      return Number(this.compareTag) === pos
        ? "bg-primary-gradient text-white"
        : "";
    },
    selectedIcon(pos) {
      return Number(this.compareTag) === pos
        ? "check_box"
        : "check_box_outline_blank";
    },
    tagType(tag) {
      if (tag.type === "B") {
        return "Brand";
      } else if (tag.type === "C") {
        return "Category";
      } else {
        return "Brand Family";
      }
    },
    fetchStat(unitType, pos) {
      return this.artefact.res.overall[this.fetchTagOf(unitType, pos)] ? this.artefact.res.overall[this.fetchTagOf(unitType, pos)] : 0;
    },
    makeUnitStatsData(unitType, pos) {
      let plot = [];
      let unitData = this.artefact.res.detail[unitType][pos];
      for (let i = 0; i < unitData.length; i++) {
        plot.push(
          Math.round(unitData[i].metric * Math.pow(10, 2)) / Math.pow(10, 2)
        );
      }

      let series = [
        {
          name:
            this.artefact.mode === "revenue" ? "$ Sales" : "Quantity Sold",
          data: plot
        }
      ];

      this.comparePerformance();

      return series;
    },
    comparePerformance() {
      let compareValue = this.fetchStat("comparison", this.compareTag);
      let baseValue = this.fetchStat("base", this.baseTag);
      this.baseChartColor = baseValue >= compareValue ? "success" : "warning";
      this.compareChartColor =
        compareValue >= baseValue ? "success" : "warning";
    },
    fetchPerformer() {
      let baseStat = this.fetchStat("base", this.baseTag);
      let compareStat = this.fetchStat("comparison", this.compareTag);
      return baseStat > compareStat
        ? this.fetchTagOf("base", this.baseTag)
        : this.fetchTagOf("comparison", this.compareTag);
    },
    updateVisualizer(tag) {
      this.compareTag = this.fetchCompareTags()
        .indexOf(tag)
        .toString();
      this.comparePerformance();
    },
    calculateOverallDI() {
      let baseStat = this.fetchStat("base", this.baseTag);
      let compareStat = this.fetchStat("comparison", this.compareTag);
      return compareStat > 0 ? baseStat / compareStat : baseStat;
    },
    calculateOverallTOR() {
      let tor =
        this.calculateOverallDI() !== 0 ? 100 / this.calculateOverallDI() : 100;
      return tor;
    },
    calculateDI(index) {
      let baseIndex = this.baseUnitSelected.index;
      return index > 0 && baseIndex !== index? (baseIndex / index) : 0;
    },
    calculateMetricBasedTOR(index) {
      let baseMetric = this.baseUnitSelected.metric;
      let compareMetric = this.compareUnitSelected.metric;
      return compareMetric > 0 && baseMetric !== compareMetric? (baseMetric / compareMetric) : 0;
    },
    calculateTOR(index) {
      // let tor =
      //   this.calculateDI(index) !== 0 ? (100 / this.calculateDI(index)) : 1;
      // let tor =
      //   this.calculateMetricBasedTOR(index) !== 0 ? (100 / this.calculateMetricBasedTOR(index)) : 1;
      let tor = this.calculateMetricBasedTOR(index) !== 0 ? this.calculateMetricBasedTOR(index) : 1;
      return tor;
    },
    checkStatsPanel() {
      let isBaseSelected =
        this.baseUnitSelected && this.baseUnitSelected.pointer;
      let isCompareSelected =
        this.compareUnitSelected && this.compareUnitSelected.pointer;

      this.showCompare = isBaseSelected && isCompareSelected;
      this.showUnitContrib =
        !this.showCompare && (isBaseSelected || isCompareSelected);

      this.showStatsPanel = this.showCompare || this.showUnitContrib;
    },
    findUnitProgress(unitVal, overallVal) {
      return ((overallVal !== 0 && unitVal !== 0) ? (unitVal/overallVal) : unitVal) *100; 
    },
    decorateMetric(metric, mode) {
      return (mode === 'revenue' ? '$' : '') + metric + (mode === 'revenue' ? '' : ' units');
    },
    fetchTagOfSelectedUnitStats() {
      let isBaseSelected =
        this.baseUnitSelected && this.baseUnitSelected.pointer;
      let isCompareSelected =
        this.compareUnitSelected && this.compareUnitSelected.pointer;
        
      return isBaseSelected ? this.baseUnitSelected.pointer : this.compareUnitSelected.pointer;  
    },
    fetchPerformanceHistory() {
      let exploreTags = [];
      let queryType = this.artefact.type;
      let triggerMode = this.artefact.mode === 'revenue' ? 'revenue' : 'quantity';
      let histroyDateRange = appCommons.allowedDateScope(this.artefact.dateRange.endDate, 365, 'minus', '', '');

      let isBaseSelected =
        (this.baseUnitSelected && this.baseUnitSelected.pointer) ? true : false;
      let isCompareSelected =
        (this.compareUnitSelected && this.compareUnitSelected.pointer) ? true : false;

      let unit = isBaseSelected ? this.baseUnitSelected : this.compareUnitSelected;
      
      exploreTags.push(unit);
        //Dummy query for dev purpose and later will use recent seaerches from cache to fill this

      this.payload = {
        tags: exploreTags,
        dateRange: histroyDateRange,
        query: 'Unit Performance History',
        mode: triggerMode,
        type: queryType,
        res: {}
      };

      if((isBaseSelected && !isCompareSelected) || (!isBaseSelected && isCompareSelected)) {
        this.$vs.loading({
          // background: this.backgroundLoading,
          // color: this.colorLoading,
          container: "#history-panel",
          // scale: 0.45,
          type: "radius"
        });

        fetchArtefactUnit(this.payload)
          .then(data => {
            this.selectedUnitStats = data.data[0];
            this.isLoading = false;
            this.$vs.loading.close("#history-panel > .con-vs-loading");
            // this.$vs.loading.close();
          })
          .catch(error => {
            this.selectedUnitStats = {};
            this.isLoading = false;
            this.$vs.loading.close("#history-panel > .con-vs-loading");
            // this.$vs.loading.close();
            throw new Error(error);
          });
      } else {
        this.selectedUnitStats = {};
        this.isLoading = false;
      }
      // this.$store.dispatch('sandbox/'+FETCH_SANDBOX_ARTEFACT_UNIT, this.payload);

      return true;
    },
    unitStats() {},

    activatePrompt(ref, pos) {
      this.activePrompt=true;
      this.fileName = this.fetchTagOf(ref, pos) + "_Units";
      this.exportData = this.fetchDataOf(ref, pos);
    },
    exportToExcel() {
      import('@/app/shared/vendor/Export2Excel').then(excel => {
        const list = this.exportData;
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    clearFields() {
      this.filename = "",
      this.cellAutoWidth = true,
      this.selectedFormat = "xlsx"
    }

    // ...mapGetters({selectedUnitStats: "sandbox/artefactUnit"})
  },
  mounted() {
    // this.baseUnitSelected = this.fetchDataOf('base', this.baseTag);
    // this.compareUnitSelected = this.fetchDataOf('comparison', this.compareTag);
  },
  components: {
    AgGridVue,
    StatisticsCardLine,
    VueApexCharts,
    ChangeTimeDurationDropdown,
    vSelect
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/pages/profile.scss";
#compare {
  .tagger {
    padding: 0.5rem 1rem;
    border-radius: 25px;
    margin-right: 1rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
      0 5px 15px 0 rgba(0, 0, 0, 0.08);
  }
  .tasks-today-container {
    .tasks-today__task {
      transition: background 0.15s ease-out;
      .tasks-today__actions {
        display: none;
      }

      &:hover {
        background: rgba(var(--vs-primary), 0.04);
        .tasks-today__actions {
          display: flex;
        }
      }
    }
  }

  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
